<template>

  <MenuProducts/>
</template>

<script>

import MenuProducts from '@/components/MenuProducts';
export default {
  name: 'HomeView',
  components: {

    MenuProducts,
  }
}
</script>